import { useTheme } from '@emotion/react';
import Add from '@mui/icons-material/Add';
import { Box, Breadcrumbs, Button, CircularProgress, Dialog, DialogContent, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getSupplieDetailApi, updateSupplierApi } from '../../../redux/Supplier/action';
import { INVENTORY_TYPES, PART_TYPES } from '../../../utility/Constant';
import SuccessMessageModal from '../../Common/SuccessMessage';
import AddInventoryModal from '../../Inventory/AddInventory';
import './SupplierProfile.css';
import SupplierProfileLeftSection from './SupplierProfileLeftSection';
import SupplierProfileRightSection from './SupplierProfileRightSection';

function SupplierProfile(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [quickEdit, setQuickEdit] = useState(false);
    const [supplierDetails, setSupplierDetails] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [type, setType] = useState(PART_TYPES.PARTS);
    const [openInventoryModel, setOpenInventoryModal] = useState(false);
    const [selectedInventoryId, setSelectedInventoryId] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [addressValues, setAddressValues] = useState({
        street_number: '',
        city: '',
        province: '',
        postal: '',
        country: '',
        provinceId: '',
        cityId: '',
    });

    const fetchSupplierDetail = async (id) => {
        const resp = await dispatch(getSupplieDetailApi(id));
        if (resp) {
            setSupplierDetails(resp);
        }
        setShowLoader(false);
    };

    useEffect(() => {
        if (id) {
            fetchSupplierDetail(id);
        }
    }, []);
    const onSubmitInventoryModal = async (values) => {
        setType(PART_TYPES.PARTS);
        setSelectedInventoryId(null);
    };
    const quickUpdateSupplier = async (values) => {
        setShowLoader(true);
        if (values.city) {
            delete values.city;
        }
        if (values.province) {
            delete values.province;
        }
        let payload = values;
        const resp = await dispatch(updateSupplierApi(id, payload));
        if (resp) {
            fetchSupplierDetail(id);
            setQuickEdit(false);
        }
    };

    return (
        <Box padding={'32px 24px'} sx={{ bgcolor: 'white' }}>
            <Grid container spacing={0} sx={{ padding: '16px 0px 16px 0px' }} gap={'8px'}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div role="presentation">
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                to="/suppliers"
                                style={{
                                    color: '#000000DE',
                                    textDecoration: 'none',
                                }}
                            >
                                Supplier
                            </Link>
                            <Link
                                style={{
                                    color: '#000000DE',

                                    textDecoration: 'none',
                                }}
                            >
                                {!showLoader && supplierDetails?.name ? supplierDetails?.name ?? 'Profile' : ''}
                            </Link>
                        </Breadcrumbs>
                    </div>
                </Grid>
                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} rowGap={{ lg: 2 }}>
                    <Grid item lg={3.8} md={12} sm={12} xs={12} xl={5}>
                        <Typography variant="h4" sx={{ fontWeight: 500 }}>
                            Supplier Profile
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        lg={8.2}
                        xl={7}
                        sx={{
                            display: 'flex',
                            justifyContent: { lg: 'end' },
                            flexWrap: { xs: 'wrap', sm: 'nowrap' }, // Allow wrapping on smaller screens
                            gap: 2,
                            pointerEvents: quickEdit ? 'none' : 'auto',
                            opacity: quickEdit ? '0.5' : '',
                        }}
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Add />}
                            size={'large'}
                            sx={{ whiteSpace: 'nowrap' }} // Prevent label from wrapping
                            onClick={() => {
                                setType(PART_TYPES.PARTS);
                                setOpenInventoryModal(true);
                            }}
                        >
                            Part
                        </Button>

                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Add />}
                            size="large"
                            sx={{ whiteSpace: 'nowrap' }} // Prevent label from wrapping
                            onClick={() => {
                                setType(PART_TYPES.TYRE);
                                setOpenInventoryModal(true);
                            }}
                        >
                            Tire
                        </Button>

                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Add />}
                            size="large"
                            sx={{ whiteSpace: 'nowrap' }}
                            onClick={() => navigate(`/suppliers/suppliers-invoice/${id}`)}
                            // Prevent label from wrapping
                        >
                            Supplier Invoice
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container mt={'41px'} columnSpacing={3} rowGap={3}>
                <Grid
                    item
                    container
                    height={'fit-content'}
                    xs={12}
                    sm={12}
                    md={12}
                    lg={5.1}
                    xl={3.5}
                    borderRadius={'4px'}
                    sx={{ justifyContent: 'flex-start', position: { md: 'relative', lg: 'sticky' }, top: { sm: 'auto', lg: '90px' }, scrollbarWidth: 'none' }}
                >
                    <SupplierProfileLeftSection
                        supplierId={id}
                        setQuickEdit={setQuickEdit}
                        quickEdit={quickEdit}
                        supplierDetails={supplierDetails}
                        quickUpdateSupplier={quickUpdateSupplier}
                        addressValues={addressValues}
                        setAddressValues={setAddressValues}
                        setShowLoader={setShowLoader}
                        fetchSupplierDetail={fetchSupplierDetail}
                    />
                </Grid>

                <Grid
                    item
                    container
                    xs={12}
                    md={12}
                    sm={12}
                    lg={6.9}
                    xl={8.5}
                    sx={{
                        opacity: quickEdit ? '0.5' : '',
                        pointerEvents: quickEdit ? 'none' : 'auto',
                    }}
                >
                    <SupplierProfileRightSection supplierId={id} />
                </Grid>
            </Grid>

            {/* Add Inventory  */}
            <AddInventoryModal
                type={INVENTORY_TYPES.SUPPLIER}
                supplierId={id}
                partType={type}
                inventoryId={selectedInventoryId}
                openModal={openInventoryModel}
                closeModal={() => {
                    setType(PART_TYPES.PARTS);
                    setOpenInventoryModal(false);
                    setSelectedInventoryId(null);
                }}
                onSubmitModal={onSubmitInventoryModal}
                hideTabs
                setShowLoader={setShowLoader}
                showLoader={showLoader}
                fetchApi={() => {}}
                ShowAllTabs={false}
                ShowTabIndex={0}
                modalType="add"
            />

            <Dialog fullScreen={false} open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
        </Box>
    );
}

export default SupplierProfile;
